import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "./store";
import { getOrgId } from "./orgHelpers";
import { CreateUserDto } from "../models/User";
import { supplierService } from "../services/SupplierService";
import { openToast } from "./ToastSlice";

interface SupplierState {
    modalStatus: boolean,
    modalLoading: boolean,
    fetchLoading: boolean,
    suppliersOrganization: Array<any> | null
}

const initialState : SupplierState = {
    modalStatus: false,
    modalLoading: false,
    fetchLoading: false,
    suppliersOrganization: null
}

const supplierSlice = createSlice({
  name: "supplier",
  initialState,
  reducers: {
    setSupplierModalStatus : (state, action :PayloadAction<boolean>) => {
      state.modalStatus = action.payload
    },
    setSupplierModalLoading : (state, action :PayloadAction<boolean>) => {
      state.modalLoading = action.payload
    },
    setSupplierfetchLoading : (state, action :PayloadAction<boolean>) => {
      state.fetchLoading = action.payload
    },
    setSuppliersOrganization : (state, action :PayloadAction<Array<any>>) => {
      state.suppliersOrganization = action.payload
    },
  }
})

export const {
    setSupplierModalStatus,
    setSupplierModalLoading,
    setSupplierfetchLoading,
    setSuppliersOrganization
} = supplierSlice.actions

export default supplierSlice.reducer;

export const fetchSupplier = ()  : AppThunk<Promise<void>> => async (dispatch, getState) => {
    dispatch( setSupplierfetchLoading(true));

    const state = getState();
    const id = getOrgId(state);

    try {
        const addSupplier = await supplierService.getAllSuppliers(id);
        if (!addSupplier) throw new Error('erro ao pegar os fornecedores');
        dispatch(setSuppliersOrganization(addSupplier));
    } catch (e) {
        console.error(e);
    } finally {
        dispatch( setSupplierfetchLoading(false));
    }
}
    

export const createSupplier = (payload:CreateUserDto)  : AppThunk<Promise<void>> => async (dispatch, getState) => {
    
    dispatch( setSupplierModalLoading(true));
    
    const state = getState();
    payload.organizationId = getOrgId(state)

    try {
        const addSupplier = await supplierService.addSupplier(payload);
        if (!addSupplier) throw new Error('erro ao adicionar o fornecedor');
        dispatch(fetchSupplier())
        dispatch(openToast({ title: "Fornecedor adicionado", message: "Fornecedor cadastrado com sucesso.", effect: "success" }));
        dispatch(setSupplierModalStatus(false)); // fecha o modal SO no sucesso
    } catch (e: any) {
        console.error(e);
        // err.response.data do backend chega aqui (ex.: { message: [...] }).
        const msg = Array.isArray(e?.message) ? e.message.join(' · ') : (e?.message || "Nao foi possivel adicionar o fornecedor.");
        dispatch(openToast({ title: "Erro ao adicionar fornecedor", message: msg, effect: "error" }));
    } finally {
        dispatch( setSupplierModalLoading(false));
    }
}